import React, { useState } from 'react';

interface IContext {
  fullScreenContentId: string | null;
  setFullScreenContentId: (id: string | null) => void;
}

export const FullScreenTrackingContext: React.Context<IContext> =
  React.createContext<IContext>({
    fullScreenContentId: null,
    setFullScreenContentId: () => {},
  });

type Props = React.PropsWithChildren<unknown>;

const FullScreenTrackingContextProvider: React.FC<Props> = (
  props: Props
): JSX.Element => {
  const { children } = props;

  const [fullScreenContentId, setFullScreenContentId] = useState<string | null>(
    null
  );

  const context = { fullScreenContentId, setFullScreenContentId };

  return (
    <FullScreenTrackingContext.Provider value={context}>
      {children}
    </FullScreenTrackingContext.Provider>
  );
};

export default FullScreenTrackingContextProvider;
